function groupBy(arr, groupByKey) {
    const output = [];
    arr.forEach((item) => {
        const index = output.findIndex((a) => a.key === item[groupByKey]);
        if (index !== -1) {
            // @ts-ignore
            output[index]["items"].push(item);
        }
        else {
            output.push({ key: item[groupByKey], items: [item] });
        }
    });
    return output;
}

export { groupBy };
//# sourceMappingURL=groupBy.js.map
